import { render, staticRenderFns } from "./CarBattery.vue?vue&type=template&id=4edbfaac&"
import script from "./CarBattery.vue?vue&type=script&lang=js&"
export * from "./CarBattery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports